import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";
import { usersApi } from "../api";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams";

const loginAs = async (id) => {
  let { organization_id } = getBaseUrlParams();
  try {
    await usersApi.loginAs({ organization_id, id: id.toString() });
    window.location.replace("/");
  } catch (err) {
    console.log(err);
  }
};

export const LoginAs = ({ isOpen, onClose, selected: { id } = {} }) => {
  const primaryBtnHandler = () => {
    loginAs(id);
    onClose();
  };

  return (
    <MainModal
      parentSelector=".users"
      isOpen={isOpen}
      onClose={onClose}
      headerText="Login As User to Test"
      headerCloseHandler={onClose}
      width={500}
      height="auto"
      primaryButtonText="Login As"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="primary"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      secondaryBtnClass="secondary"
      containerClassName="dialog"
      isAdminPanel={false}
    >
      You will be logged out of current user and logged into selected user to verify the users
      permissions. Proceed?
    </MainModal>
  );
};
